import { useAppSelector } from '@app/hooks';
import { RootState } from '@app/store';
import Header from '@features/Common/Header';
import HomeProvider from '@features/home/components/HomeProvider';
import Provisioning from '@features/provisioning/components/Provisioning';
import { Box, Typography } from '@mui/material';
import { useMemo } from 'react';

const ProvisionHome = () => {
  const userTenant = useAppSelector((state: RootState) => state.userTenant);
  const tenant = useAppSelector((state: RootState) => state.tenant);
  const property  = useAppSelector((state: RootState) => state.property);

  const currentTenant = useMemo(() => tenant.currentTenant || userTenant, [tenant.currentTenant, userTenant]);

  if (!property.property_id) return <></>;

  return (
    <>
      <Header />
      <Box
        component="div"
        sx={{
          margin: '1em',
          padding: '2em',
        }}
      >
        <Typography variant="h4">{currentTenant.name}</Typography>
        <Typography variant="h5">
          Provisioning devices for {property.name || 'new RIoT Home'}
        </Typography>
        <Box
          component="div"
          sx={{
            mt: '3em',
          }}
        >
          <HomeProvider>
            <Provisioning />
          </HomeProvider>
        </Box>
      </Box>
      </>
  );
}

export default ProvisionHome;